import { getContrastingColor } from './contrat-color';
import { getRippleColor } from './ripple-color';

export const setDefaultMaterialColors = (color = '#000000') => {
  document.body.style.setProperty('--mat-toolbar-container-background-color', color);
  document.body.style.setProperty('--mat-slide-toggle-selected-handle-color', color);
  document.body.style.setProperty('--mat-slide-toggle-selected-track-color', color);
  document.body.style.setProperty('--mat-toolbar-container-text-color', getContrastingColor(color));
  document.body.style.setProperty('--mdc-tab-indicator-active-indicator-color', color);
  document.body.style.setProperty('--mat-tab-header-active-label-text-color', color);
  document.body.style.setProperty('--mdc-outlined-text-field-focus-outline-color', color || '#000');
  document.body.style.setProperty('--mat-radio-checked-ripple-color', color || '#000');
  document.body.style.setProperty('--mat-form-field-outlined-focus-outline-color', color || '#000');
  document.body.style.setProperty('--mat-radio-selected-hover-icon-color', color || '#000');
  document.body.style.setProperty('--mat-radio-selected-icon-color', color || '#000');
  document.body.style.setProperty('--mat-radio-selected-pressed-icon-color', color || '#000');
  document.body.style.setProperty('--mat-snack-bar-button-color', color || '#000');
  document.body.style.setProperty('--ctr-btn-color', color);
  document.body.style.setProperty('--ctr-btn-text-color', getContrastingColor(color));
  document.body.style.setProperty('--ctr-stroked-btn-text-color', color);
  document.body.style.setProperty('--ctr-input-focus-color', color);
  document.body.style.setProperty('--ctr-error-color', '#ff284f');
  document.body.style.setProperty('--ctr-chip-active-background', color);
  document.body.style.setProperty('--ctr-chip-active-color', getContrastingColor(color));
  document.body.style.setProperty('--mat-ripple-color', getRippleColor(color));
  document.body.style.setProperty('--mat-fab-container-color', color);
  document.body.style.setProperty('--mat-fab-icon-color', getContrastingColor(color));
  document.body.style.setProperty('--ctr-info-card-color', color);
  document.body.style.setProperty('--ctr-primary-color', color);
  document.body.style.setProperty('--ctr-primary-color-transparent', `${color}33`);
  document.body.style.setProperty('--ctr-primary-color-semi-transparent', `${color}41`);
  document.body.style.setProperty('--ctr-contrast-color', getContrastingColor(color));
  document.body.style.setProperty('--mat-option-selected-state-label-text-color', color);
  document.body.style.setProperty('--mat-select-focused-arrow-color', color);
};
